import React from 'react';

import { Image } from 'react-native';

import { UnsubscribedIcon } from 'assets/images';

import { COLOR } from 'utils/colors';
import { isWeb } from 'utils/responsiveness';

import styles from './styles';

type Props = {
    playing?: boolean;
    testID?: string;
};

function EpgUnsubscribedIcon({ playing, testID }: Props) {
    if (isWeb) {
        return (
            <UnsubscribedIcon
                testID={testID}
                fill={playing ? COLOR.background : COLOR.NEUTRAL}
                style={styles.root}
            />
        );
    }

    return (
        <Image
            testID={testID}
            source={{
                uri: playing
                    ? 'icon_epg_unsubscribed_black'
                    : 'icon_epg_unsubscribed',
            }}
            style={styles.root}
        />
    );
}

export default React.memo(EpgUnsubscribedIcon);
